import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { useTeamsAuth } from "@/features/auth/TeamsAuthProvider";
import { parseSubPageId } from "@/lib/teamsDeepLink";

/**
 * Navigates once on mount to the URL encoded in the Teams `subPageId`
 * context, so notification deep links land directly on the right view
 * instead of the plain email list.
 */
export function DeepLinkHandler(): null {
  const { context } = useTeamsAuth();
  const navigate = useNavigate();
  const handled = useRef(false);

  useEffect(() => {
    if (handled.current) return;
    const parsed = parseSubPageId(context?.subPageId);
    if (!parsed) {
      handled.current = true;
      return;
    }
    handled.current = true;

    if (parsed.kind === "email") {
      navigate(`/?email=${encodeURIComponent(parsed.emailId)}`, { replace: true });
      return;
    }

    const docPath = `/review/${encodeURIComponent(parsed.documentId)}`;
    const suffix = parsed.emailId
      ? `?fromEmail=${encodeURIComponent(parsed.emailId)}`
      : "";
    navigate(`${docPath}${suffix}`, { replace: true });
  }, [context?.subPageId, navigate]);

  return null;
}
